import React from 'react';

import { IonBadge } from '@ionic/react';

import clsx from 'clsx';

import { useUser } from 'auth/User';

import './index.css';

interface ImpersonateConfig {
  className?: string;
}

const Impersonate = ({ className }: ImpersonateConfig) => {
  const { user } = useUser();

  if (!user?.impersonatedBy) {
    return null;
  }

  return (
    <IonBadge className={clsx(['impersonate-badge', className])}>
      {`Impersonate ${user.name}`}
    </IonBadge>
  );
};

export default Impersonate;
